export default function currency(value, symbol = '€') {
    if (!value) return `0.00 ${symbol}`;
    let number = parseFloat(value);
    if (isNaN(number)) return `0.00 ${symbol}`;
    return `${number.toFixed(2)} ${symbol}`;
}